import bannerStrand from '../../assets/images/Banner_Strand.png'
import usaFlag from '../../assets/images/usa-flag.svg'

export const termsAndConditionsOfSaleContent = {
    "sys": {
      "type": "Array"
    },
    "total": 1,
    "skip": 0,
    "limit": 100,
    "items": [
      {
        "fields": {
          "name": "Terms and Conditions of Sale Page",
          "title": "Terms and Conditions of Sale",
          "slug": "terms-and-conditions-of-sale",
          "seo": {
            "metadata": {
              "tags": [],
              "concepts": []
            },
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "n9bebhw263o0"
                }
              },
              "id": "VzsBqUoBa9aOy2WVSJ1Av",
              "type": "Entry",
              "createdAt": "2023-07-18T22:09:37.099Z",
              "updatedAt": "2023-07-18T22:09:37.099Z",
              "environment": {
                "sys": {
                  "id": "sandbox",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "publishedVersion": 13,
              "revision": 1,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "seo"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "name": "Terms and Conditions of Sale Page - Compose: SEO"
            }
          },
          "content": {
            "metadata": {
              "tags": [],
              "concepts": []
            },
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "n9bebhw263o0"
                }
              },
              "id": "4DgFjVJ4vgmLu3t2WxKcbU",
              "type": "Entry",
              "createdAt": "2023-07-18T22:09:37.123Z",
              "updatedAt": "2023-07-18T22:28:46.333Z",
              "environment": {
                "sys": {
                  "id": "sandbox",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "publishedVersion": 15,
              "revision": 2,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "richTextContentPageTemplate"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "name": "Terms and Conditions of Sale Page - Rich Text Content Page Template",
              "modules": [
                {
                  "metadata": {
                    "tags": [],
                    "concepts": []
                  },
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "n9bebhw263o0"
                      }
                    },
                    "id": "B7Nw3RClc2mJ9e6hvjl0w",
                    "type": "Entry",
                    "createdAt": "2023-07-18T22:19:31.415Z",
                    "updatedAt": "2023-07-18T22:19:31.415Z",
                    "environment": {
                      "sys": {
                        "id": "sandbox",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "publishedVersion": 4,
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "bannerComponent"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Terms and Conditions of Sales Banner Component",
                    "headline": "Moderna's Terms and Conditions of Sale",
                    "backgroundImage": {
                      "metadata": {
                        "tags": [],
                        "concepts": []
                      },
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "n9bebhw263o0"
                          }
                        },
                        "id": "5zfGJA7or5WGcLdYi4Qde",
                        "type": "Asset",
                        "createdAt": "2022-10-28T18:53:29.208Z",
                        "updatedAt": "2022-10-28T18:53:29.208Z",
                        "environment": {
                          "sys": {
                            "id": "sandbox",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "publishedVersion": 6,
                        "revision": 1,
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Banner BG Strand Top",
                        "description": "",
                        "file": {
                          "url": bannerStrand,
                          "details": {
                            "size": 47693,
                            "image": {
                              "width": 1920,
                              "height": 511
                            }
                          },
                          "fileName": "Banner BG Strand Top .png",
                          "contentType": "image/png"
                        }
                      }
                    },
                    "country": {
                      "metadata": {
                        "tags": [],
                        "concepts": []
                      },
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "n9bebhw263o0"
                          }
                        },
                        "id": "7sht7920U6vs3CLH2CUyaa",
                        "type": "Entry",
                        "createdAt": "2023-05-18T03:23:50.744Z",
                        "updatedAt": "2023-05-24T22:55:23.250Z",
                        "environment": {
                          "sys": {
                            "id": "sandbox",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "publishedVersion": 6,
                        "revision": 2,
                        "contentType": {
                          "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "country"
                          }
                        },
                        "locale": "en-US"
                      },
                      "fields": {
                        "name": "United States",
                        "isocode": "US",
                        "flag": {
                          "metadata": {
                            "tags": [],
                            "concepts": []
                          },
                          "sys": {
                            "space": {
                              "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "n9bebhw263o0"
                              }
                            },
                            "id": "3aYCbZJiL8aoEKRdhjOXyy",
                            "type": "Asset",
                            "createdAt": "2023-05-24T22:54:50.939Z",
                            "updatedAt": "2023-05-24T22:54:50.939Z",
                            "environment": {
                              "sys": {
                                "id": "sandbox",
                                "type": "Link",
                                "linkType": "Environment"
                              }
                            },
                            "publishedVersion": 5,
                            "revision": 1,
                            "locale": "en-US"
                          },
                          "fields": {
                            "title": "usa flag",
                            "description": "USA Flag",
                            "file": {
                              "url": usaFlag,
                              "details": {
                                "size": 2487,
                                "image": {
                                  "width": 36,
                                  "height": 26
                                }
                              },
                              "fileName": "usa_flag.svg",
                              "contentType": "image/svg+xml"
                            }
                          }
                        },
                        "locales": [
                          "en-US"
                        ]
                      }
                    }
                  }
                },
                {
                  "metadata": {
                    "tags": [],
                    "concepts": []
                  },
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "n9bebhw263o0"
                      }
                    },
                    "id": "1gueYHjtTvECRTMjM6Xbjs",
                    "type": "Entry",
                    "createdAt": "2023-07-18T22:24:29.349Z",
                    "updatedAt": "2024-08-05T18:30:34.851Z",
                    "environment": {
                      "sys": {
                        "id": "sandbox",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "publishedVersion": 240,
                    "revision": 13,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "richTextContentComponent"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Terms and Conditions of Sale Rich Text Component - US",
                    "content": {
                      "nodeType": "document",
                      "data": {},
                      "content": [
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Moderna’s Terms and Conditions of Sale",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "These terms and conditions of sale (hereinafter “Terms” or “Agreement”), which may be amended by Moderna US, Inc. (“Moderna”) from time to time in its sole discretion, govern all direct purchases from Moderna by eligible customers (“Purchaser” or “Purchasers”) for FDA authorized and/or approved products sold commercially by Moderna (“Product”) through Moderna Direct (Moderna’s e-commerce website at https://modernadirect.com). Each direct purchase shall be deemed an acknowledgement and acceptance by Purchaser of these Terms in effect at the time of such purchase, and such Terms are hereby incorporated by reference into any and all invoices issued by Moderna in connection with direct purchases through Moderna Direct.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "1. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Purchase and Use of Product.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "1.1. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Eligibility.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " Purchaser eligibility to purchase Product will be at the sole discretion of Moderna. No Purchaser may resell Product or market, promote, administer, or use Product for the benefit of persons or entities outside the United States or its territories. The pricing, terms and conditions of this Agreement shall apply only to Purchasers located in the United States and its territories.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "1.2.",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "“Own Use.”",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Purchaser agrees that Product purchased under this Agreement is for the “own use” of Purchaser as defined by the United States Supreme Court in ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Abbott Laboratories v. Portland Retail Druggists Association, Inc.",
                              "marks": [
                                {
                                  "type": "italic"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": ", 425 U.S. 1 (1976) and ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Jefferson County Pharmaceutical Association, Inc. v. Abbott Laboratories",
                              "marks": [
                                {
                                  "type": "italic"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": ", 103 S. Ct. 1011 (1983). Purchaser further agrees that it shall not administer Product in a manner that is inconsistent with the foregoing and will not sell or donate Product for any reason without Moderna’s express written permission. Purchaser shall take such precautions as are necessary to prevent Product from falling into the hands of those who may not lawfully possess or handle it.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "2. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Product Orders, Modification and Cancellation, Delivery.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "2.1.",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Orders.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " Purchasers may order Product by creating a direct purchase account by calling Moderna Customer Care Team at 1-866-Moderna (633-3762) or visiting Moderna Direct (Moderna’s e-commerce website at https://modernadirect.com). Purchasers authorize Moderna and its agents or representatives to place orders for Product via Moderna Direct on Purchasers’ behalf, to the extent requested by and at the direction of Purchaser. These Terms supersede any terms and conditions included in any purchase order received from Purchaser, which shall not apply to any sale under these Terms. Each order submitted by a Purchaser is subject to Moderna’s confirmation of the Purchaser’s valid state license number, other license authorizations, and the Purchaser’s creditworthiness.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "2.2. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Modification and Cancellation.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " Upon ordering Product and upon confirmation of an order by Moderna, a Purchaser shall have committed to purchase the amount of the order.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "2.3. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Delivery.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " Moderna will use commercially reasonable efforts to fulfill orders as Product availability allows. However, Moderna’s obligation to deliver Product ordered by a Purchaser is subject at all times to (a) any superseding requirement imposed by any governmental authority, including without limitation any requirement imposed in connection with an epidemic or pandemic, (b) delays in Product lot releases, and (c) the condition that Moderna is able to manufacture a sufficient supply of Product to meet the demands of all of its customers. Further, Moderna shall, in its sole discretion, have the right to delay shipments, make partial deliveries, and allocate Product among its customers in such a manner as it deems appropriate. In addition, in the event that a government authority assumes control of Product allocation (as a result of shortage or other reason) or requires that specific requirements be met, then Product amounts and delivery schedules may be changed to meet the government authority’s requirements and Moderna will be relieved, without incurring any liability, of all obligations to supply or deliver Product ordered by any Purchaser.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "3. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Storage, Handling and Destruction.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " Purchasers taking physical possession of Product are fully responsible for complying with all applicable federal, state, and local laws and regulations relating to storage, handling, and distribution of Product. Purchaser represents and warrants that it has and will maintain at all times the proper license or licenses required to receive, handle and store vaccines. Purchaser shall store and handle Product consistent with the Product Prescribing Information. Purchaser further represents that it will take appropriate steps to properly dispose of empty vaccine containers and product packaging by (1) treating containers and packaging similarly to medical waste by placing in red sharps containers (preferred), or (2) defacing or safely crushing materials so they cannot be reintroduced or reproduced, and then disposing of them with regular waste.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "4. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Payment Terms and Instructions.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "4.1.",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Payment Terms.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Purchasers shall be obligated to pay for Product, via credit card, ACH, check, or bank transfer by the payment due date specified in the invoice delivered by Moderna upon shipment. Prompt pay discount of 2% 60, net 61 days shall apply to the invoice total inclusive of applicable tax. ",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "4.2.",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Claims and Deductions.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " All claims involving discounts, pricing, credits or returns must be reported to Moderna within sixty (60) days of the date of invoice for the purchase in question. Inappropriate deductions taken from Purchaser payments, including but not limited to, those made after this deadline, will be reflected against the account and could jeopardize future shipment on open items.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "4.3.",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Amounts Overdue.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " If Purchaser fails to pay amounts when due hereunder, Moderna reserves the right to commence any collection proceedings as it deems appropriate, including referring Purchaser to a third-party collector or commencing litigation. Moderna reserves the right to charge fees to Purchaser associated with the collection process. Fees may include, without limitation, litigation costs, dunning and returned check/ACH/wire transfers or credit decline charges. A Purchaser’s account may be closed by Moderna upon being sent to third party collections. In any legal action by Moderna for nonpayment, Moderna shall be entitled to recover all costs of legal proceedings, including reasonable attorneys’ fees and an interest fee of the lesser of 1.5% per month or the maximum permissible rate.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "4.4.",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Set-off.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " Moderna reserves the right, in its sole discretion and at any time, to withhold and set-off against amounts that Purchaser owes Moderna any outstanding credits, reimbursements and refunds owed by Moderna to Purchaser, or its Affiliates. “",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Affiliate",
                              "marks": [
                                {
                                  "type": "underline"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "” means, with respect to an entity, any corporation, company, partnership, joint venture and/or firm which controls, is controlled by or is under common control with such entity. Purchaser acknowledges and agrees that it shall not be entitled to receive, and Moderna may continue to withhold, any credits, reimbursements and refunds owed to Purchaser and its Affiliates until such time as Purchaser has paid all outstanding amounts owed on purchases hereunder together with applicable interest and costs of collection. Any dormant or inactive Purchaser accounts that have credit balances more than two (2) years old will be subject to the escheatment process. This right of set-off shall survive and continue to apply following the termination or expiration of these Terms and the delivery of Product hereunder.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "5. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Credit Terms",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": ".",
                              "marks": [
                                {
                                  "type": "underline"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " Purchaser must maintain a credit condition satisfactory to Moderna. Purchaser shall substantiate its credit position upon Moderna’s request. If, in Moderna’s sole discretion, Purchaser’s credit position becomes unsatisfactory, or Purchaser’s account exhibits poor or delinquent payment history, Moderna may require prepayment for future purchases.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "6. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Product Price.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " The unit price for Product is set at the time of purchase in the amount established by Moderna and excludes surcharges for shipping (if any) where applicable, and excise taxes or assessments. Purchaser is responsible to remit to Moderna for applicable taxes as included on Invoice. All prices are subject to change without notice. ",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "7. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Taxes.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " All prices or fees set forth are exclusive of any applicable sales, excise, or other taxes that Moderna is required by law to collect from the Purchaser. When the Purchaser elects to make payment via credit card, Moderna shall calculate the appropriate tax amount by the applicable tax jurisdiction(s) of the Purchaser’s ship to location at the time of purchase. The final amount charged to the Purchaser’s credit card shall include such calculated tax. The purchaser acknowledges that tax rates may vary and that any changes in applicable taxes during the term of this Agreement will be reflected in the amounts charged to the Purchaser’s credit card. If the Purchaser is tax exempt, the Purchaser must provide Moderna with a valid tax exemption certificate authorized by the appropriate taxing authority before the transaction. Moderna shall not include tax in the credit card charge, subject to validity of the exemption certificate. Failure to provide tax exempt documentation will result in the Purchaser being liable for the payment of all taxes due. Any discrepancies or disputes regarding the calculation of taxes must be reported to Moderna within (30) days of the credit card statement date on which the charge appeared. Moderna will investigate the claim and rectify as applicable with accordance to our sales tax policy and governing laws. Purchaser agrees to indemnify and hold Moderna, the Seller, harmless from any claims, damages, or expenses associated with the failure to pay any taxes related to credit card payments, except for those taxes that are legally the responsibility of Moderna. ",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "8. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Claims for Loss and Inspection of Product.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "8.1. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Claims for Loss or Damage in Shipments",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": ".",
                              "marks": [
                                {
                                  "type": "underline"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " Claims for loss, shortage, breakage, leakage, or other damage occurring in transit must be submitted to Moderna at its headquarters twenty-four (24) hours from date of invoice, for replacement or credit of affected Product. The sole and exclusive remedy of Purchaser is Moderna credit or replacement, as applicable, of affected Product. Purchaser agrees that no other remedy (including but not limited to, incidental, consequential, or other damages of any kind) shall be available. Loss, shortage, breakage, leakage, or other damage claims must also be accompanied by freight bill with notation by the common carrier of the loss, shortage, breakage, or damage, or accompanied by the carrier’s concealed loss or damage report where the loss is of a concealed nature. Where loss, shortage, breakage, leakage, or other damage has occurred in transit, Purchaser agrees to cooperate fully with Moderna in Moderna’s effort to establish a claim against the transportation company. Claims submitted without appropriate documentation will be denied.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "8.2.",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Inspection of Product by Purchaser.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " Purchaser must, within three (3) business days after delivery of Product, conduct a physical inspection of the packaged Product and notify Moderna’s Customer Service at 1-866-MODERNA (633-3762) of any issue or physical damage that is apparent from such inspection. If a Purchaser fails to give such notice, then the Purchaser will be conclusively presumed to have accepted such shipment and Moderna will have no liability to the Purchaser for any defects that could have been identified by such inspection nor for any discrepancies between the shipment received and the amount of Product ordered by the customer. Any defect or damage to the Product that is not identifiable from a physical inspection will remain grounds for rejection of Product if the Purchaser notifies Moderna’s Customer Service at 1-866-MODERNA (633-3762) within three (3) business days following discovery of the defect or damage. Upon receipt of such notice from a Purchaser, Moderna will conduct an investigation and if Moderna agrees with the Purchaser’s determination, Moderna will use reasonable commercial efforts to supply replacement Product to the Purchaser or if no replacement Product can be supplied, Moderna will, in its sole discretion, issue a credit note to the Purchaser for the rejected Product. If Moderna, in its sole discretion, determines in good faith that no defect or damage to Product exists, then the Purchaser must accept delivery of such Product and pay the invoiced amount. In the event that Moderna determines that no defect or damage exists, then Moderna will not be deemed to be in breach of these Terms nor have any further liability with respect to the alleged defect or damage.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "8.3. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Limitations and Damages.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "The sole and exclusive remedy of Purchaser is Moderna credit or replacement, as applicable, of affected Product. Purchaser shall not sell or use affected Product and shall indemnify Moderna against third-party claims arising from the impermissible sale or use of affected Product.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "9. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Returns.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "All returnable doses purchased directly from Moderna via Moderna Direct must be returned in accordance with Moderna’s Returned Goods Policy, available at ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "https://modernadirect.com/return-goods-policy"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "https://modernadirect.com/return-goods-policy",
                                  "marks": [],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": ". Product not purchased directly from Moderna should be returned under its terms of sale. If such Product is returned to Moderna directly, it will be either be returned or destroyed at Moderna’s sole discretion, and no credit will be provided. Product supplied through the federal Vaccines for Children program or any other government program contract where Product is purchased under special conditions is not eligible for return credit or replacement.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "10. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Passage of Title; Risk of Loss.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "For all orders of Products shipped to any of the fifty (50) states in the United States, title to Product and risk of loss of each such shipment of Product will pass to the Purchaser upon delivery to the destination designated by the Purchaser in the Purchaser’s direct purchase account. For all orders of Product shipped to a U.S. territory: Moderna shall deliver all Product Delivered at Place (DAP) (Incoterms 2020); title to and risk of loss for any such Product shall transfer over international waters following shipment of Product by Moderna or its designated agent and prior to any importation, provided, however, that the rights and procedures set forth in Section 8 shall continue to apply; Moderna shall obtain all required export licenses and shall pay the cost of carriage to the destination (with the exception of any special shipping requests, the cost of which shall be borne by Purchaser); and Purchaser shall be responsible for all import clearance and formalities, including import duties, taxes, and any other charges payable upon importation of Products into a U.S. territory. ",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "11. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Warranties of Purchaser.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " By ordering Product from Moderna, Purchaser:",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "a. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Acknowledges that the Product has been FDA-approved (and is recommended by Moderna) only for use as described in the Product Prescribing Information (“PI”), which outlines the Product’s approved indications, uses, dosages, and routes of administration, as well as additional information regarding the Product’s efficacy, safety, contraindications, warnings, and risks. Purchaser acknowledges that Moderna makes no representations or warranties related to any use of the Product that does not conform with the FDA-approved PI. Purchaser further acknowledges that Moderna disclaims any and all liability for any use of the Product that does not conform with the FDA-approved PI.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "b. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Acknowledges that Product is not to be used after the expiration date printed on the Product label.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "c. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Acknowledges that Product is not to be used if it has been stored or handled inconsistent with applicable laws and the Product Prescribing Information.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "d. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Agrees that, as requests for information or correspondence in relation to Product are made of a Purchaser by a governmental authority, unless otherwise required by law, Purchaser shall consult with Moderna and keep Moderna fully apprised of all such communications.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "12. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Safety Information Reporting.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " For purposes of this Section 12, the following definitions shall apply: ",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "“",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Adverse Event",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "” or “",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "AE",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "” is any untoward medical occurrence in a patient or clinical investigation subject administered a pharmaceutical product and which does not necessarily have to have a causal relationship with this treatment. An adverse event (AE) can therefore be any unfavorable and unintended sign (including an abnormal laboratory finding, for example), symptom, or disease temporally associated with the use of a medicinal product, whether or not considered related to the medicinal product. ",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "“",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Special Situation",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "” includes, but is not limited to: ",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "unordered-list",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "any exposure during pregnancy or at time of conception (maternal or paternal) and/or lactation,",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "suspected transmission of infectious agent, ",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "abuse or misuse, ",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "medication error (potential, intercepted or actual) or overdose, ",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "occupational exposure, ",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "failure of the Moderna product to exhibit its expected pharmacologic or biologic effect,",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "unexpected benefit, ",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "off-label use, ",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "falsified or counterfeit medicinal product, ",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "drug-vaccine or drug, drug interaction, ",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "complaint (including but not limited to any product quality complaint), or ",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "query with respect to any Moderna product.",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "If Purchaser, or its subcontractors, designees, or delegates, becomes aware of an AE/Special Situation or query with respect to the Product, Purchaser shall provide such AE/Special Situation report or query to Moderna via secure e-mail at ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "mailto:drugsafety@modernatx.com"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "drugsafety@modernatx.com",
                                  "marks": [],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": " as soon as practicable, but no later than one (1) business day after such report is received. Purchaser shall include the date the report was received and shall use reasonable efforts to gather and provide the following information regarding the AE/Special Situation or query: (a) name of the Moderna product; (b) description of potential AE/Special Situation or query, including a description of the relationship between the product and AE/Special Situation or query, as applicable; (c) identifying patient demographics; and (d) contact information of the reporting individual. ",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "13. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Compliance with Laws.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " Purchaser shall comply with all Federal, state and local laws, requirements and regulations as they relate to its performance under the Agreement. Without limitation of the foregoing, Purchaser will comply with applicable provisions of the Drug Supply Chain Security Act, and all federal and state healthcare anti-fraud and abuse laws, including the federal anti-kickback statute, 42 U.S. C. 1320a-7b, prohibiting illegal remunerations (including any kickback, bribe, or cost incentive) by properly disclosing and appropriately reflecting the discounts and rebates described in this Agreement in the costs claimed or the charges made under the Medicaid, Medicare or any federal healthcare program. To that end, Purchaser shall properly document the pricing made available hereunder in Purchaser's records setting forth the acquisition cost of Product and, if Medicare, Medicaid or any other Federal or State-funded healthcare program requests information as to the cost of Product acquired hereunder, Purchaser shall properly and accurate disclose such pricing, including fully and accurately disclosing any discounts for Product purchased hereunder as required under 42 CFR 1001.952(h) or other applicable law or regulation. ",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "14. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Withdrawal of Product Approval.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " Moderna will promptly notify Purchaser in writing of any withdrawal of Product’s FDA approval or emergency use authorization or of Product’s material non-compliance with FDA standards. At the request of Moderna, Purchaser agrees to return to Moderna, at Moderna’s sole cost and expense, any allegedly defective Product owing to the withdrawal of Product’s approval or authorization, or a determination of material non-compliance by Moderna or by the FDA.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "15. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "No License of Intellectual Property Rights.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " Nothing in these Terms shall be construed as granting or implying the grant of any license under any patent or trademark rights or any other intellectual property rights held by Moderna or any of its Affiliates anywhere in the world, and Moderna shall be entitled to exercise such patent or trademark rights and/or other intellectual property rights to the fullest extent legally permissible at the time of such exercise. Purchaser may not remove, alter or obscure any trademark on the Product.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "16. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Confidential Information.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "16.1.",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " By ordering Product, Purchaser agrees that any and all information it obtains regarding Moderna in connection with a purchase of Product, including without limitation pricing information, discounts/rebates obtained, volume incentives and all other contract information, whether or not marked as “confidential,” is ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "“",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Confidential Information",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "” of Moderna. By ordering Product, Purchaser further acknowledges and agrees that any and all Confidential Information disclosed by Moderna to Purchaser is and will remain the property of Moderna, and Purchaser agrees to return any Moderna Confidential Information promptly upon written request and to retain no copies or excerpts of such Confidential Information.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "16.2.",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " By ordering Product, Purchaser further agrees that: (a) any and all Confidential Information disclosed by Moderna to such Purchaser is and will remain the property of Moderna; (b) it will use Confidential Information only to perform obligation or exercise rights under this Agreement; (c) it will not disclose Moderna’s Confidential Information to any third party without the prior written consent of Moderna (except as required to comply with law or court order); (d) it may disclose Moderna’s Confidential Information to its employees and/or independent contractors only to the extent that such employees and/or independent contractors are reasonably required by their duties to have knowledge of such Confidential Information, and provided that such employees and/or independent contractors are contractually obligated to hold such Confidential Information in confidence and to otherwise comply with these Terms; (e) it will not hold Moderna or its employees liable for any errors or omissions in Moderna’s Confidential Information; and (f) it will use reasonable care to safeguard Moderna’s Confidential Information and make no misuse of such Confidential Information.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "16.3.",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " Purchaser’s obligations under this Section will remain in effect for a period of five (5) years from the date that the last order was submitted by Purchaser under these Terms.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "17. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Force Majeure.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Neither party will be held liable to the other party nor be deemed to have defaulted under or breached this Agreement for failure or delay in performing any obligation under this Agreement (except for any obligation to make payment for doses already delivered) to the extent that such failure or delay is caused by or results from causes beyond the reasonable control of the affected party (a “Force Majeure Event”), including strikes or other labor disturbances, lockouts, riots, quarantines, communicable disease outbreaks, wars, acts of terrorism, cyber-attacks, fires, floods, storms, interruption of or delay in transportation, lack of and inability to obtain fuel, power or components, or compliance with any order, regulation, or enforcement decision of any governmental authority. The affected party will notify the other party of such Force Majeure Event as soon as reasonably practical, and will promptly undertake all reasonable efforts necessary to cure such Force Majeure Event and resume performance of its obligations hereunder.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "18. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Warranties of Moderna.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " Moderna warrants that: Product delivered shall hereunder, at the time of delivery, materially conform to the applicable Specification (“Specification” means the specifications or similar requirements for the manufacture of Product that are provided by Moderna to Purchaser, from time to time, in writing and expressly designated as such); (b) at the time of Delivery, the Product will not be adulterated or misbranded within the meaning of the Federal Food, Drug and Cosmetic Act, as amended, all applicable regulations thereunder, or within the meaning of any applicable law within which the definitions of “adulteration” or “misbranding” are substantially the same as those contained in the Federal Food, Drug and Cosmetic Act, as such Act and such applicable laws are constituted and effective at the time of Delivery, nor will the Product be an article which may not, under the provisions of such Act, or of the Public Health Service Act, as amended, be introduced into interstate commerce; (c) Moderna’s quality control procedures applicable to Product shall have been materially carried out prior to delivery of Product; and (d) upon delivery to the destination, title to Product will pass to Purchaser free and clear of all third party liens, claims, security interests, or other encumbrances.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "THIS SECTION SETS FORTH MODERNA’S SOLE AND LIMITED WARRANTIES WITH RESPECT TO PRODUCT SUPPLIED TO PURCHASER. TO THE MAXIMUM EXTENT ALLOWED BY LAW, EXCEPT AS UNAMBIGUOUSLY AND EXPRESSLY SET FORTH IN THIS SECTION, MODERNA SPECIFICALLY DISCLAIMS, AND, BY ORDERING PRODUCT, EACH PURCHASER IS EXPRESSLY WAIVING AND RELEASING MODERNA FROM ALL OTHER WARRANTIES, CONDITIONS AND TERMS REGARDING OR RELATING TO PRODUCT (WHETHER USED ALONE OR WITH OTHER SUBSTANCES OR MATERIALS) THAT MAY HAVE BEEN PROVIDED TO A PURCHASER OR OTHERWISE THAT MIGHT HAVE EFFECT BETWEEN A PURCHASER AND MODERNA OR BE IMPLIED INTO THESE TERMS, PRODUCT ORDER, OR ANY OTHER COLLATERAL CONTRACT, WHETHER BY STATUTE, COMMON LAW OR OTHERWISE AND WHETHER EXPRESS, IMPLIED OR OTHERWISE, INCLUDING ALL IMPLIED WARRANTIES, CONDITIONS OR TERMS OF MERCHANTABILITY, QUALITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. MODERNA WILL NOT BE LIABLE TO ANY PURCHASER, AND, BY ORDERING PRODUCT, EACH PURCHASER IS EXPRESSLY WAIVING AND RELEASING MODERNA FROM ANY LIABILITY, WITH RESPECT TO PRODUCT (AN “UNCOVERED PRODUCT”) THAT (A) HAS BEEN TAMPERED WITH OR IN ANY WAY ALTERED OR MODIFIED AFTER DELIVERY TO THE PURCHASER’S DESIGNATED DESTINATION; (B) HAS BEEN SUBJECT TO MISUSE, NEGLIGENCE OR ACCIDENT AFTER DELIVERY TO THE PURCHASER’S DESIGNATED DESTINATION; (C) HAS BEEN STORED, HANDLED, MAINTAINED, ADMINISTERED OR USED IN A MANNER CONTRARY TO REGULATORY REQUIREMENTS, THE LABELING OF PRODUCT OR MODERNA’S INSTRUCTIONS, OR OTHERWISE NOT AS ORIGINALLY INTENDED, AFTER DELIVERY TO THE PURCHASER’S DESIGNATED DESTINATION; OR (D) HAS PASSED ITS EXPIRATION DATE. THE WARRANTIES CONTAINED IN THIS AGREEMENT WILL NOT APPLY TO ANY SUCH UNCOVERED PRODUCT.",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "19. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Indemnification by Purchasers.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " By ordering Product, Purchaser agrees to indemnify, defend and hold harmless Moderna and its Affiliates, and each of their directors, officers, employees and agents from and against any and all damages, losses, liabilities, cost, and expenses (including reasonable attorneys’ fees) directly arising out of (a) any material breach of any representation or warranty of Purchaser; (b) any action by Purchaser, its directors, officers, employees or agents with respect to any Product resulting in such Product becoming an Uncovered Product; (c) the subsequent sale and/or use of an Uncovered Product (d) the negligent or more culpable act or omission of Purchaser or its affiliates, or any allegation related thereto; and (e) the breach of this Agreement by Purchaser. Purchaser shall maintain commercially reasonable insurance programs and limits, consistent with Purchaser’s company size and industry risk profile, from insurers rated by A.M. Best at least Financial Strength A- or better, and Financial Size Category VII or better, to satisfy its indemnification obligations hereunder.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "20. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Limitations of Liability.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Under no circumstances whatsoever will Moderna be liable to Purchaser or its affiliates in contract, tort, negligence, indemnity, breach of statutory duty, or otherwise, for: (a) any (direct or indirect) delay, penalty, loss of profits, of anticipated savings, of business, of goodwill, or of use of the Product or costs of any substitute services; (b) any reliance damages; or (c) for any other liability, damage costs, penalty, or expense of any kind incurred by Purchaser of an indirect or consequential nature, regardless of the foreseeability or any notice of the possibility of these damages.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "21. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "No Agency Relationship.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " The relationship created by these Terms is a buyer-seller relationship and not an agency relationship.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "22. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Assignment.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " Purchaser shall not sell, assign, or transfer to any third party, and past, present or future obligation, covenant, or claim of any nature whatsoever relating to any matter covered by the Agreement, without Moderna’s written consent.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "23. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Notice",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": ".",
                              "marks": [
                                {
                                  "type": "underline"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " All communications required under this Agreement must be in written or electronic form. All such communications by Moderna to Purchaser will be to the contact person listed at the “Ship To” address in the direct purchase account established by Purchaser. All such communications by Purchaser to Moderna must be sent to the attention of:",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Moderna US, Inc.\n5 Vaughn Dr., Suite 200\nPrinceton, NJ 08540\nEmail: ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "mailto:commercialops@modernatx.com"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "commercialops@modernatx.com",
                                  "marks": [],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": "\nWith an email copy to your Moderna Account Manager; and\nWith an email copy to: ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "mailto:legal@modernatx.com"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "legal@modernatx.com",
                                  "marks": [],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "24. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Governing Law and Jurisdiction.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " These Terms will be governed by, construed and interpreted in accordance with the laws of the Commonwealth of Massachusetts, without regard to any choice of law principle that would require the application of the law of another jurisdiction. Each part irrevocably submits to the exclusive jurisdiction of the courts of the Commonwealth of Massachusetts, or of the United States of America for the District of Massachusetts.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "25. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Waiver",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": ".",
                              "marks": [
                                {
                                  "type": "underline"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " The waiver by Moderna of a breach of these Terms or any default hereunder shall not be deemed a waiver of any subsequent default whether of the same or similar nature and shall not in any way affect the Terms herein. No waiver shall be valid or binding unless in writing and signed by the parties.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "26. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Severability.",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " In the event any term or provision of this Agreement is declared illegal, unenforceable or in conflict with any law or regulation, the validity of any other term or provision shall not be affected thereby.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "27. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Entire Agreement; Contract Purchaser",
                              "marks": [
                                {
                                  "type": "underline"
                                },
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": ".",
                              "marks": [
                                {
                                  "type": "underline"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " This Agreement shall prevail over any inconsistent or conflicting terms in any other agreement between Purchaser and Moderna; provided that, if Purchaser is party to a separate written contract with Moderna when an order is placed and a provision in the separate written contract specified by Purchaser for such order conflicts with a provision in this Agreement, then the provision in the separate written contract shall prevail over the conflicting provision in this Agreement with respect to such order. The terms and conditions of any purchase order or other document issued by Purchaser (whether in writing, electronic or otherwise) that conflict with or are in addition to these Terms or the terms and conditions stated on an invoice issued by Moderna are expressly rejected by Moderna and superseded hereby.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Last updated 08",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "/05/24",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": ".",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        }
                      ]
                    },
                    "backToTopButtonLabel": "Back To Top",
                    "printButtonLabel": "Print",
                    "country": "[Circular Reference]"
                  }
                }
              ]
            }
          }
        },
        "sys": {
          "id": "2fYeJxk3IiLk32qYZYHaG5",
          "type": "Entry"
        }
      }
    ],
    "includes": {
      "Entry": [
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]"
      ],
      "Asset": [
        "[Circular Reference]",
        "[Circular Reference]"
      ]
    }
}